import * as actionTypes from "./SuperAdminTypes";
import { Get, Post } from "../../helpers/apicalls/apicalls";
import { message } from "antd";

export const Get_Companies = (data, token) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.GET_COMPANIES_LOADING });
    Post("/agents/user/admin/getCompanies", data, token)
      .then(function (response) {
        if (response.status) {
          dispatch({
            type: actionTypes.GET_COMPANIES_SUCCESS,
            payload: response?.data,
          });
        } else {
          dispatch({ type: actionTypes.GET_COMPANIES_FAILED });
        }
      })
      .catch(function (error) {
        dispatch({ type: actionTypes.GET_COMPANIES_FAILED });
      });
  };
};

export const Get_Companies_Details = (data, token) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.GET_COMPANIES_DETAILS_LOADING });
    Post("/agents/user/admin/getCompaniesDetails", data, token)
      .then(function (response) {
        if (response.status) {
          dispatch({
            type: actionTypes.GET_COMPANIES_DETAILS_SUCCESS,
            payload: response?.data,
          });
        } else {
          dispatch({ type: actionTypes.GET_COMPANIES_DETAILS_FAILED });
        }
      })
      .catch(function (error) {
        dispatch({ type: actionTypes.GET_COMPANIES_DETAILS_FAILED });
      });
  };
};


export const addorEditPrompts = (data, token, handleCancel) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.BRAND_PORPMTS_LOADING });
    Post("/agents/user/admin/addAndEditBrandContent", data, token)
      .then(function (response) {
        if (response.status) {
          message.success('successfully');
          dispatch({
            type: actionTypes.BRAND_PORPMTS_SUCCESS,
            payload: response?.data,
          });
          handleCancel()
        } else {
          dispatch({ type: actionTypes.BRAND_PORPMTS_FAILED });
        }
      })
      .catch(function (error) {
        dispatch({ type: actionTypes.BRAND_PORPMTS_FAILED });
      });
  };
};
export const getPrompts = (data, token) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.GET_BRAND_PORPMTS_LOADING });
    Post("/agents/user/admin/getBrandContent", data, token)
      .then(function (response) {
        if (response.status) {
          dispatch({
            type: actionTypes.GET_BRAND_PORPMTS_SUCCESS,
            payload: response?.data,
          });
        } else {
          dispatch({ type: actionTypes.GET_BRAND_PORPMTS_FAILED });
        }
      })
      .catch(function (error) {
        dispatch({ type: actionTypes.GET_BRAND_PORPMTS_FAILED });
      });
  };
};

export const Get_Widget_Cdn = () => {
  return (dispatch) => {
    dispatch({ type: actionTypes.GET_WIDGET_CDN_LOADING });
    Post("/agents/user/get-widget-cdn")
      .then(function (response) {
        if (response.status) {
          dispatch({
            type: actionTypes.GET_WIDGET_CDN_SUCCESS,
            payload: response?.data,
          });
        } else {
          dispatch({ type: actionTypes.GET_WIDGET_CDN_FAILED });
        }
      })
      .catch(function (error) {
        dispatch({ type: actionTypes.GET_WIDGET_CDN_FAILED });
      });
  };
};

export const Update_Widget_Cdn = (data, onSuccess) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.UPDATE_WIDGET_CDN_LOADING });
    Post("/agents/user/admin/update-widget-cdn", data)
      .then(function (response) {
        if (response.status) {
          message.success(response?.message || "Widget CDN URL updated");
          dispatch({
            type: actionTypes.UPDATE_WIDGET_CDN_SUCCESS,
            payload: response?.data,
          });
          if (onSuccess) onSuccess();
        } else {
          message.error(response?.message || "Failed to update Widget CDN URL");
          dispatch({ type: actionTypes.UPDATE_WIDGET_CDN_FAILED });
        }
      })
      .catch(function (error) {
        message.error("Failed to update Widget CDN URL");
        dispatch({ type: actionTypes.UPDATE_WIDGET_CDN_FAILED });
      });
  };
};

